import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAliasForMetricGroupId } from '../../../api/alias/utils';
import { SQLFilters } from '../../../api/types';
import { MetricId as GraphQLMetricId } from '../../../api/types-graphql';
import {
  useAliasesContext,
  useEffectiveRoleViewAuthorizationServiceContext,
  useGlobalLocaleContext,
  useMetricDetailsMapContext,
} from '../../../context/contexts';
import { MetricIdType, Segmentation, TimeSelection } from '../../../types';
import { MetricQueryTooltip } from '../modals/MetricQueryModal';
import { SingleValueTimePeriodTooltip } from '../modals/SingleValueTimePeriodModal';
import { UserFilterTooltip } from '../modals/UserFilterModal';
import { showTitle } from '../utils-display';
import { useGetMetricDisplayName } from './hooks';

export const ChartTitle = (props: {
  metrics: MetricIdType[];
  metricsSql: (string | null)[];
  timeSelection: TimeSelection;
  title?: string;
  segmentations?: Segmentation[];
  userFilters?: SQLFilters;
}) => {
  const { t } = useTranslation();
  const {
    metrics,
    metricsSql,
    timeSelection,
    title,
    segmentations,
    userFilters,
  } = props;

  const metricDetailsMap = useMetricDetailsMapContext();
  const aliases = useAliasesContext();
  const locale = useGlobalLocaleContext();
  const authorizationService =
    useEffectiveRoleViewAuthorizationServiceContext();
  const getAliasForMetric = getAliasForMetricGroupId(aliases, locale.selected);
  const metricDetails = metrics.map(
    (m) => metricDetailsMap[m.value as unknown as GraphQLMetricId]
  );
  const alias = metricDetails.map((md) => getAliasForMetric(md.metricGroupId));
  const getMetricDisplayName = useGetMetricDisplayName();
  const canSeeChartDevOptions = authorizationService.canSeeChartDevOptions();
  return (
    <Typography sx={{ zIndex: 1 }}>
      {showTitle(
        metrics,
        metricDetails.map((md) => md.metricGroupId),
        timeSelection,
        getMetricDisplayName,
        t,
        title,
        segmentations
      )}
      {canSeeChartDevOptions && (
        <MetricQueryTooltip metrics={metrics} metricsSql={metricsSql} />
      )}
      {canSeeChartDevOptions && <UserFilterTooltip userFilters={userFilters} />}
      <SingleValueTimePeriodTooltip timeSelection={timeSelection} />
    </Typography>
  );
};
